<template>
  <div class="right-card-wrap">
    <div class="header-title-wrap">
      <span class="title">趋势分析</span>
    </div>
    <div class="analysis-right-top-wrap">
      <div class="top-item" v-for="(item, index) in totalList" :key="index">
        <span>{{ item.name }}<span class="suffix">/件数</span></span>
        <span class="analysis-text">{{ item.value }}</span>
        <ChangeCard name="同比增长" :value="item.increase"></ChangeCard>
      </div>
    </div>
    <div class="mid-line-wrap">
      <eLine ref="lineInstance" :options="lineOptions"></eLine>
    </div>
    <div class="header-title-wrap">
      <span class="title">技术主题分析</span>
    </div>
    <div class="bottom-theme-wrap">
      <div
        v-for="(item, index) in themeList"
        :key="item"
        :class="`point${index + 1}`"
        class="text-overflow"
      >
        {{ item }}
      </div>
      <!-- <span class="point2">复合材料</span>
      <span class="point3">石墨烯</span>
      <span class="point4">电润湿</span>
      <span class="point5">电解液</span> -->
      <!-- <span class="point6">负极材料</span> -->
    </div>
  </div>
</template>

<script>

// const totalList = [
//   { name: '授权量', value: 820, increase: '11.4%' },
//   { name: '有效量', value: 328, increase: '11.4%' },
//   { name: '转化量', value: 201, increase: '11.4%' },
// ]
const TEMPLATEID = process.env.VUE_APP_BASE_TEMPLATEID
import eLine from '@/components/BigScreen/Line'
import ChangeCard from './ChangeCard.vue'
import { getchartData, getGrowthData } from '@/api/databaseBin'
import dayjs from 'dayjs'
const themeParams = {
  firstDim: 'IPC_TYPE',
  measureFields: ['application_num'],
  querys: [
    {
      operation: 'IN',
      property: 'PATENT_TYPE',
      value: 'invent,newKind,exterior'
    },
    {
      operation: 'EQUAL',
      property: 'IPC_TYPE',
      value: 'mainClass'
    },
    {
      operation: 'LESS_EQUAL',
      property: 'TOP_IPC_TYPE',
      value: '6'
    }
  ],
  secondDim: '',
  viewName: 'IPC_ANALYSIS'
}

const effectiveParams = {
  firstDim: 'PUBLICATION_YEAR',
  measureFields: ['effective_num'],
  querys: [{
    operation: 'LESS_EQUAL',
    property: 'PUBLICATION_YEAR',
    value: '5'
  },
  {
    operation: 'IN',
    property: 'PATENT_TYPE',
    value: 'invent,newKind,exterior'
  }
  ],
  secondDim: '',
  viewName: 'PATENT_COUNT_ANALYSIS'
}

const authorizeParams = {
  firstDim: 'PUBLICATION_YEAR',
  measureFields: ['authorize_num'],
  querys: [{
    operation: 'LESS_EQUAL',
    property: 'PUBLICATION_YEAR',
    value: '5'
  },
  {
    operation: 'IN',
    property: 'PATENT_TYPE',
    value: 'invent,newKind,exterior'
  }
  ],
  secondDim: '',
  viewName: 'PATENT_COUNT_ANALYSIS'
}

const transferParams = {
  firstDim: 'TRANSFORM_YEAR',
  measureFields: ['transfer', 'permit', 'pledge'],
  querys: [{
    operation: 'LESS_EQUAL',
    property: 'TRANSFORM_YEAR',
    value: '5'
  }, {
    operation: 'IN',
    property: 'PATENT_TYPE',
    value: 'invent,newKind,exterior'
  }, {
    operation: 'IN',
    property: 'TRANSFORM_TYPE',
    value: 'transfer,permit,pledge'
  }
  ],
  secondDim: 'TRANSFORM_TYPE',
  viewName: 'TRANSFER_COUNT_ANALYSIS'
}

const effectiveTotal = {
  queryFilter: {
    pageBean: {
      page: 1,
      pageSize: 20
    },
    querys: [{
      group: 'main',
      operation: 'EQUAL',
      property: 'F_PATENT_STATUS',
      relation: 'AND',
      value: '有效'
    }]
  },
  templateId: TEMPLATEID
}

const authorizationTotal = {
  queryFilter: {
    pageBean: {
      page: 1,
      pageSize: 20
    },
    querys: [{
      group: 'main',
      operation: 'EQUAL',
      property: 'F_LEGAL_STATUS',
      relation: 'AND',
      value: 'authorization'
    },  {
                "group": "main",
                "operation": "EQUAL",
                "property": "F_PATENT_STATUS",
                "relation": "AND",
                "value": "有效"
            }]
  },
  templateId: TEMPLATEID
}

const aloneTransTotal = {
  queryFilter: {
    pageBean: {
      page: 1,
      pageSize: 20
    },
    querys: [{
      group: 'main',
      operation: 'LIKE',
      property: 'F_TAG_STAT',
      relation: 'AND',
      value: '转让'
    }]
  },
  templateId: TEMPLATEID
}

const aloneProTotal = {
  queryFilter: {
    pageBean: {
      page: 1,
      pageSize: 20
    },
    querys: [{
      group: 'main',
      operation: 'LIKE',
      property: 'F_TAG_STAT',
      relation: 'AND',
      value: '许可'
    }]
  },
  templateId: TEMPLATEID
}

const alonePledgeTotal = {
  queryFilter: {
    pageBean: {
      page: 1,
      pageSize: 20
    },
    querys: [{
      group: 'main',
      operation: 'LIKE',
      property: 'F_TAG_STAT',
      relation: 'AND',
      value: '质押'
    }]
  },
  templateId: TEMPLATEID
}

export default {
  data() {
    return {
      totalList: [],
      lineOptions: {}, // 折线图的配置
      themeList: [],
      NumList: [],
      effTotal: 0,
      authorTotal: 0,
      transferTotal: 0
    }
  },
  components: {
    ChangeCard,
    eLine
  },
  created() {
    this.getTrendData()
    this.getThemeData()
  },
  methods: {
    async getTrendData() {
      Promise.all([getGrowthData(aloneTransTotal), getGrowthData(aloneProTotal), getGrowthData(alonePledgeTotal)]).then(res => {
        const data = res.map(item => item.total)
        const transferTotal = data.reduce((pre, cur) => {
          pre += cur
          return pre
        }, 0)
        this.transferTotal = transferTotal
      })
      const { total: effTotal } = await getGrowthData(effectiveTotal)
      this.effTotal = effTotal
      const { total: authorTotal } = await getGrowthData(authorizationTotal)
      this.authorTotal = authorTotal

      Promise.all([getchartData(effectiveParams), getchartData(authorizeParams), getchartData(transferParams)]).then(res => {
        const dataSource = res.map(item => item.value)
        dataSource.forEach((item, index) => {
          let itemValue = ''
          let name = ''
          let allTotal = 0
          if (index === 0) {
            itemValue = 'effective_num_total'
            name = '有效量',
            allTotal = this.effTotal
          } else if (index === 1) {
            itemValue = 'authorize_num_total'
            name = '授权量',
            allTotal = this.authorTotal
          } else {
            itemValue = 'transform_total_all'
            name = '转化量',
            allTotal = this.transferTotal
          }
          const total = item.reduce((pre, cur) => {
            pre += cur[itemValue]
            return pre
          }, 0)
          const curNum = item[item.length - 1][itemValue]
          const radio = parseFloat(((curNum / (total - curNum)) * 100).toFixed(1))
          const header = {
            name: name, value: allTotal, increase: `${radio}%`
          }
          this.totalList.push(header)
          const Num = item.map(item => item[itemValue]).slice(1, 5)
          const itemList = []
          Num.reverse().reduce((pre, cur) => {
            pre += cur
            itemList.push(pre)
            return pre
          }, 0)
          const rightList = itemList.reduce((pre, cur) => {
            const data = allTotal - cur
            pre.unshift(data)
            return pre
          }, [])
          const collectList = [...rightList, allTotal]
          this.NumList.push(collectList)
        })
        this.settingLineOptions(this.NumList)
      })
    },
    async getThemeData() {
      const { value } = await getchartData(themeParams)
      const themeData = value.map(item => item.IPC_TYPE_CN)
      this.themeList = themeData
    },
    settingLineOptions(Arr) {
      this.lineOptions = this.getOpt(Arr)
      this.$nextTick(() => {
        this.$refs.lineInstance.initChart()
      })
    },
    getOpt(Arr) {
      const colorList = ['#00FFFF', '#AE00FF', '#006FE2']
      const legendNames = ['有效量', '授权量', '转化量']
      const yearArr = []
      const currentYear = dayjs().format('YYYY')
      let before5Year = currentYear - 4
      while (before5Year <= currentYear) {
        yearArr.push(before5Year)
        before5Year++
      }
      const series = colorList.reduce((pre, cur, index) => {
        pre.push({
          name: legendNames[index],
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: {
            normal: {
              width: 2,
              // shadowColor: 'rgba(155, 18, 184, .4)',
              // shadowBlur: 5,
              // shadowOffsetY: 20,
              // shadowOffsetX: 0,
              color: cur
            }
          },
          itemStyle: {
            color: cur,
            borderColor: '#fff',
            borderWidth: 1
          },
          data: Arr[index]
        })
        return pre
      }, [])
      return {
        legend: {
          show: true,
          top: 20,
          data: legendNames,
          textStyle: {
            fontSize: 10,
            color: '#c8c8c8'
          }
        },
        grid: {
          left: '25%'
        },
        xAxis: {
          boundaryGap: false,
          splitLine: { // 网格线
            lineStyle: {
              type: 'dashed', // 设置网格线类型 dotted：虚线   solid:实线
              color: '#4b556d'
            },
            show: false // 隐藏或显示
          },

          axisLine: {
            show: false,
            lineStyle: {
              color: '#0c428a'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            show: true,
            textStyle: {
              color: '#ffffff', // X轴文字颜色
              fontSize: 13
            }
          },
          data: yearArr
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ffffff', // X轴文字颜色
              fontSize: 13
            }
          }
        },
        series: series
      }
    }
  }
}
</script>
